import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Topbar from "../Global/topbar";
import TableBody2 from "../Table container/tablebody";
import "./transaction.css";
import CachedIcon from "@mui/icons-material/Cached";
import { getDetails } from "../../services/api/dashboard";
import CustomDateRange from "./CustomDateRange";
import { RiFileExcel2Line } from "react-icons/ri";
import { Button, Chip, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { exportToExcel } from "../Global/exportToExcel";

export default function Transaction() {
  const [search, setSearch] = useState("");
  const [loader, setLoder] = useState(true);
  const [data, setData] = useState(false);
  const [notfound, setNotFound] = useState(false);
  const [APIdata, setAPIdata] = useState([]);
  const menu = "transaction";
  const [reload, setReload] = useState(true);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState("");
  const deleted = true;
  const disabled = true;
  const start_key = useRef({ 1: null });
  const page = useRef(1);
  const location = useLocation();
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [excelData, setExcelData] = useState([]);

  useEffect(() => {
    setPages((prev) => !prev);
  }, [search]);

  useEffect(() => {
    const start = JSON.parse(sessionStorage.getItem("start_key"));
    const URI = JSON.parse(sessionStorage.getItem("path"));
    if (start && location.pathname === URI) {
      start_key.current = start;
    } else {
      start_key.current = { 1: null };
    }
  }, [location]);
  const fetchRecording = async () => {
    const paginationKey = start_key.current[page.current];
    getDetails(limit, paginationKey, start_date, end_date, search)
      .then((response) => {
        if (response.data.status) {
          if (response?.data?.data?.Items.length === 0) {
            setLoder(false);
            setNotFound(true);
            setData(true);
            setTotal(response?.data?.data?.total);
          } else {
            setLoder(false);
            setNotFound(false);
            setData(true);
            setTotal(response?.data?.data.total);
            setAPIdata(response?.data?.data?.Items || []);
            start_key.current[page.current + 1] =
              response?.data?.data.LastEvaluatedKey || null;
            sessionStorage.setItem(
              "start_key",
              JSON.stringify(start_key.current)
            );
          }
        } else {
          setLoder(false);
          setNotFound(true);
        }
      })
      .catch((error) => {
        setLoder(false);
        setNotFound(true);
        console.log(error.message);
      });
  };

  useEffect(() => {
    setAPIdata([]);
    setLoder(true);
    setNotFound(false);
    const delayDebounceFn = setTimeout(() => {
      fetchRecording();
    }, 500); // Debounce API calls

    return () => clearTimeout(delayDebounceFn);
  }, [search, reload, skip, limit, end_date]);

  useEffect(() => {
    if (end_date) {
      setAPIdata([]);
      setLoder(true);
      setNotFound(false);
      const delayDebounceFn = setTimeout(() => {
        fetchRecording();
      }, 100);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [start_date]);

  useEffect(() => {
    if (APIdata.length > 0) {
      getDetails("all", null, start_date, end_date, search)
        .then((response) => {
          if (response.data.status) {
            setExcelData(response?.data?.data?.Items || []);
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
  }, [APIdata]);

  const headers = [
    { topic: "#" },
    { topic: "Date" },
    { topic: "Time" },
    { topic: "User" },
    { topic: "Email" },
    { topic: "Role" },
    { topic: "Transaction For" },
    { topic: "Amount" },
    { topic: "Status" },
    { topic: "Action" },
  ];

  const cell = [
    { topic: "created_at" },
    { topic: "created_at_time" },
    { topic: "user.name" },
    { topic: "user.email" },
    { topic: "user.role" },
    { topic: "transaction_for" },
    { topic: "amount_data" },
    { topic: "status_transaction" },
  ];

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  const path = "/admin/balance_type";

  const handleDateChange = ([start, end, change]) => {
    if (start) {
      setStart_date(start);
    }
    if (end) {
      setEnd_date(end);
    }
    if (change === "clear") {
      setEnd_date("");
      setStart_date("");
    }
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    { header: "User", key: "user.name" },
    { header: "Email", key: "user.email" },
    { header: "Role", key: "user.role" },
    { header: "Transaction For", key: "transaction_for" },
    { header: "Transaction Type", key: "transaction_type" },
    { header: "Amount", key: "amount" },
    { header: "Date", key: "created_at" },
    { header: "Transaction Id", key: "id" },
  ];
  const downloadExcel = (data, type) => {
    if (type === "current") {
      exportToExcel(data, columns, "Transaction_Current_Page.xlsx");
    } else {
      exportToExcel(data, columns, "Transaction_Total_Data.xlsx");
    }
  };

  const getStatusChip = (status) => {
    switch (status) {
      case "successful":
      case "successfull":
        return (
          <Chip
            label="Successful"
            sx={{ backgroundColor: "#4caf50", color: "white" }} 
          />
        );
      case "failed":
        return (
          <Chip
            label="Failed"
            sx={{ backgroundColor: "#f44336", color: "white" }} 
          />
        );
      case "pending":
        return (
          <Chip
            label="Pending"
            sx={{ backgroundColor: "#ff9800", color: "white" }}
          />
        );
      default:
        return <Chip label={status} variant="outlined" />;
    }
  };


  return (
    <div className="transaction-main">
      <div className="transaction-user-top">
        <Topbar />
        <div className="top-mid-transaction">
          <h1>Transaction List</h1>
          <Link href="" style={{ display: "none" }}>
            Dashboard
          </Link>{" "}
          <Link to="/admin/transaction">Transaction List </Link> &#62;
        </div>
        <div className="tob-btm-transaction">
          <div className="button-box-user">
            <CustomDateRange onChange={handleDateChange} />
          </div>
          <div className="export-button-box">
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              className="username"
              style={{
                marginRight: "15px",
                background:
                  APIdata &&
                  APIdata.length > 0 &&
                  excelData &&
                  excelData.length > 0
                    ? "var(--admin-page--color)"
                    : "#1c1c1c6c",
                transition: "background 0.3s ease",
                height: "43px",
                color: "#FFFF",
                border: "1.2px solid rgb(223, 229, 172)",
                padding: "0px 10px",
              }}
              disabled={
                excelData &&
                excelData.length > 0 &&
                APIdata &&
                APIdata.length > 0
                  ? false
                  : true
              }
            >
              <RiFileExcel2Line style={{ marginRight: "5px" }} />
              Export
              <div className="name">
                <KeyboardArrowDownOutlinedIcon
                  style={{
                    color: "white",
                  }}
                />
              </div>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={() => {
                  handleClose();
                  downloadExcel(excelData, "total");
                }}
              >
                All
              </MenuItem>
              <MenuItem
                onClick={() => {
                  (handleClose(), downloadExcel(APIdata, "current"));
                }}
              >
                This Page
              </MenuItem>
            </Menu>
            <input
              type="text"
              className="input1"
              placeholder="&#61442; Search"
              onChange={(e) => {
                setSearch(e.target.value);
                setSkip(0);
                start_key.current[1] = undefined;
                page.current = 1;
              }}
              style={{
                fontfamily: "Arial, FontAwesome",
                marginRight: "6px",
              }}
            />
            <button onClick={handleReload}>
              <CachedIcon />
            </button>
          </div>
        </div>
        <div className="table1">
          <TableBody2
            headers={headers}
            APIdata={APIdata}
            cell={cell}
            path={path}
            loader={loader}
            notfound={notfound}
            data={data}
            menu={menu}
            setReload={setReload}
            setSkip={setSkip}
            total={total}
            setLimit={setLimit}
            pages={pages}
            deleted={deleted}
            newPage={page}
            disabled={disabled}
            search={search}
            getStatusChip={getStatusChip}
          />
        </div>
      </div>
    </div>
  );
}
